import { render, staticRenderFns } from "./Respondent.vue?vue&type=template&id=5854a2c9&scoped=true"
import script from "./Respondent.vue?vue&type=script&lang=js"
export * from "./Respondent.vue?vue&type=script&lang=js"
import style0 from "./Respondent.vue?vue&type=style&index=0&id=5854a2c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5854a2c9",
  null
  
)

export default component.exports